module.exports = __webpack_public_path__ + "img/reward.756d00f5.svg";